import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';

export interface IOfflineAlert {
    renderer: () => JSX.Element | null;
    show: () => void;
    hide: () => void;
    isShowing: () => boolean;
}

export const TYPES = {
    IOfflineAlert: Symbol.for('IOfflineAlert'),
};

export function injectOfflineAlert(
    container: IContainer = injectOrBuildContainer(),
): Readonly<IOfflineAlert> {
    return container.get<IOfflineAlert>(TYPES.IOfflineAlert);
}

export function bindOfflineAlert(
    val: IOfflineAlert,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IOfflineAlert>(TYPES.IOfflineAlert, val);
}

export function unbindOfflineAlert(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IOfflineAlert);
}
